import firebase from 'firebase/app';
import 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyB1k1BCmwMQusK7W8aR9oRS4kE8fn-G5h4",
  authDomain: "startup-learning.firebaseapp.com",
  databaseURL: "https://startup-learning.firebaseio.com",
  projectId: "startup-learning",
  storageBucket: "startup-learning.appspot.com",
  messagingSenderId: "929857534555",
  appId: "1:929857534555:web:2ff3c96ead9a46ac841d7e",
  measurementId: "G-CNXP7LQ28R"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default firebase;